import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { getComicById } from '@/mocks/comics';

export default function ReadPage() {
  const { id } = useParams<{ id: string }>();
  const comic = getComicById(Number(id));
  const [page, setPage] = useState(1);
  const [chapter, setChapter] = useState(comic?.chapters?.[0]);

  if (!comic || comic.chapters.length === 0 || !chapter) {
    return (
      <Layout>
        <div className="mx-auto max-w-3xl px-4 py-24 text-center">
          <h1 className="font-display text-2xl text-foreground-900">暂无可阅读的章节</h1>
          <Link to="/comics" className="mt-6 inline-block rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 hover:bg-primary-600">
            返回全部漫画
          </Link>
        </div>
      </Layout>
    );
  }

  const chapterIndex = comic.chapters.findIndex((c) => c.id === chapter.id);

  const goChapter = (dir: number) => {
    const next = comic.chapters[chapterIndex + dir];
    if (next) {
      setChapter(next);
      setPage(1);
      window.scrollTo({ top: 0 });
    }
  };

  return (
    <Layout>
      <div className="mx-auto max-w-3xl px-4 py-8 md:px-6">
        <nav aria-label="面包屑" className="mb-4 text-sm text-foreground-500">
          <ol className="flex flex-wrap items-center gap-1.5">
            <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
            <li><i className="ri-arrow-right-s-line"></i></li>
            <li><Link to={`/comic/${comic.id}`} className="hover:text-primary-600">{comic.title}</Link></li>
            <li><i className="ri-arrow-right-s-line"></i></li>
            <li><span className="text-foreground-700">{chapter.title}</span></li>
          </ol>
        </nav>

        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200 pb-4">
          <div>
            <h1 className="font-display text-lg text-foreground-900">{comic.title} · {chapter.title}</h1>
            <p className="mt-1 text-xs text-foreground-500">{comic.author} · 人气 {comic.views} · 更新 {chapter.updated}</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => goChapter(-1)}
              disabled={chapterIndex === 0}
              className="rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-700 hover:bg-background-200 disabled:opacity-40"
            >
              上一话
            </button>
            <button
              type="button"
              onClick={() => goChapter(1)}
              disabled={chapterIndex === comic.chapters.length - 1}
              className="rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 hover:bg-primary-600 disabled:opacity-40"
            >
              下一话
            </button>
          </div>
        </div>

        <div className="mt-6 overflow-hidden rounded-xl border border-background-200 bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=anime%20comic%20page%20storyboard%20panel%20layout%20with%20dynamic%20action%20scenes%20and%20speech%20bubbles%2C%20warm%20orange%20vermillion%20and%20teal%20ink%20illustration%2C%20clean%20manga%20linework%2C%20high%20detail&width=1000&height=1400&seq=reader-panel-base-2026&orientation=portrait"
            alt={`${comic.title} ${chapter.title} 漫画分镜`}
            title={`${comic.title} ${chapter.title} 漫画`}
            className="h-auto w-full object-top"
          />
          <div className="flex items-center justify-between border-t border-background-200 bg-background-50 px-4 py-3">
            <button
              type="button"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600"
            >
              <i className="ri-arrow-left-line"></i> 上一页
            </button>
            <span className="text-xs text-foreground-500">第 {page} / {page + 2} 页</span>
            <button
              type="button"
              onClick={() => setPage((p) => p + 1)}
              className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600"
            >
              下一页 <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div className="mt-6">
          <h2 className="mb-3 text-sm font-semibold text-foreground-900">章节切换</h2>
          <div className="flex flex-wrap gap-2">
            {comic.chapters.map((ch) => (
              <button
                key={ch.id}
                type="button"
                onClick={() => { setChapter(ch); setPage(1); window.scrollTo({ top: 0 }); }}
                className={`rounded-full px-3.5 py-1.5 text-xs whitespace-nowrap ${ch.id === chapter.id ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-700 hover:bg-background-200'}`}
              >
                {ch.title}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}